import { render, staticRenderFns } from "./ContainerComplex.vue?vue&type=template&id=505f44a0&scoped=true&"
import script from "./ContainerComplex.vue?vue&type=script&lang=js&"
export * from "./ContainerComplex.vue?vue&type=script&lang=js&"
import style0 from "./ContainerComplex.vue?vue&type=style&index=0&id=505f44a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505f44a0",
  null
  
)

export default component.exports